export default __webpack_public_path__ + "static/media/arrow-down-black.5e89d40d.svg";